<script setup>
import { showModal, hideModal } from '@/Utils/modalBus'
import { computed, getCurrentInstance } from 'vue'
import { useStore } from 'vuex'
import IconBase from '@/components/icon/IconBase.vue'
import IconPlus from '@/components/icon/IconPlus.vue'
import IconPlay from '@/components/icon/IconPlay.vue'
import IconBook from '@/components/icon/IconBook.vue'
import IconDestinationEmptyPlaceholderImage from '@/components/icon/IconDestinationEmptyPlaceholderImage.vue'
import FormButton from '../Atoms/FormButton.vue'
import DemoVideoModal from '../modals/DemoVideoModal.vue'

const store = useStore()
const instance = getCurrentInstance()
const root = instance.proxy.$root;

// Props
const props = defineProps({
	action: {
		type: Function,
	}
})

// Computed
const hasDestinations = computed(() => store.getters['User/hasDestinations'])

// Methods
const showTutorialModal = () => showModal('modal_tutorial');
</script>

<template>
	<div class="mt-24 text-center flex flex-col w-1/4 mx-auto items-center">
		<icon-base width-view-box="48" height-view-box="48" width="48" height="48" iconColor="none" class="mb-3">
			<icon-destination-empty-placeholder-image />
		</icon-base>
		<div>
			<h3 class="text-surface-9 mb-2">Set up your first destination</h3>
			<p class="mb-4 text-sm text-dark-7">Add a destination once, then reuse it across any of your streams.</p>
			<FormButton type="secondary" target="_blank" href="https://docs.castr.com/en/articles/8799194-reusable-destinations" class="w-full mb-3 justify-center" size="lg">
				<icon-base width-view-box="15" height-view-box="16" iconColor="none" width="15" height="16" class="text-dark-8" classIcon="mr-2">
					<icon-book />
				</icon-base>
				How destinations work
			</FormButton>
			<FormButton type="secondary" @click="showTutorialModal" class="w-full justify-center mb-3" size="lg">
				<icon-base width-view-box="16" height-view-box="16" iconColor="none" width="16" height="16" class="text-dark-8" classIcon="mr-2">
					<icon-play />
				</icon-base>
				Watch a demo
			</FormButton>
			<FormButton v-if="hasDestinations" @click="props.action()" class="w-full justify-center" type="main" size="lg">
				<icon-base width-view-box="14" height-view-box="14" iconColor="none" width="14" height="14" classIcon="mr-2">
					<icon-plus />
				</icon-base>
				Add destination
			</FormButton>
			<FormButton v-else to="/subscribe" class="w-full text-center justify-center" size="lg">
				Upgrade
			</FormButton>
		</div>
	</div>
	<demo-video-modal modalId="modal_tutorial" videoid="kO9HgfAKelvf7YQ-KSSwQ" />
</template>

<style scoped>
</style>